export enum ReportStatus {
  NONE,
  WAITING_SAMPLE,
  IN_PROGRESS,
}
